Pegasus.ColumnOperationsView = Em.View.extend({
  classNames: ['vr-column-operations'],
  templateName: 'controls/column_operations',
  positionMe: function(){
    var column = this.get('controller.content');
    var zoom = this.get('controller.zoomValue');

    if ( !this.$() ) { return; }
    if ( !column )   {
      this.$().css({
        top: -9e4,
        left: -9e4
      });

      return;
    }

    var $column = column.$();
    var $offsetParent = $column.offsetParent();
    var offsetPosition = $offsetParent.position();
    var columnPosition = $column.position();

    var top = columnPosition.top + offsetPosition.top;
    var left = columnPosition.left + offsetPosition.left;
    var columnWidth = $column.outerWidth(true);
    var columnHeight = $column.outerHeight(true);

    var actualLeft = ((100*left) / (zoom*100)) * 100;
    var actualTop = ((100*top) / (zoom*100)) * 100;

    this.$().css({
      top: actualTop,
      left: actualLeft,
      width: columnWidth,
      height: columnHeight
    });
  }.observes('controller.content'),
  moveLeftView: Em.View.extend({
    classNames: ['vr-move-column-left'],
    click: function(){
      this.get('controller').moveContentLeft();
      this.set('content', null);
    }
  }),
  moveRightView: Em.View.extend({
    classNames: ['vr-move-column-right'],
    click: function(){
      this.get('controller').moveContentRight();
      this.set('content', null);
    }
  }),
  deleteView: Em.View.extend({
    classNames: ['vr-delete-column'],
    template: Em.Handlebars.compile('{{t g.delete}}'),
    click: function(){
      this.get('controller').deleteContent();
      this.set('content', null);
    }
  }),
  copyView: Em.View.extend({
    classNames: ['vr-copy-column'],
    template: Em.Handlebars.compile('{{t g.copy}}'),
    click: function(){
      this.get('controller').cloneContent();
      this.set('content', null);
    }
  }),
});

